import { render } from "./uptd.vue?vue&type=template&id=a2a582b0"
import script from "./uptd.vue?vue&type=script&lang=js"
export * from "./uptd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__